<template>
  <div>
    <div id="navigation" class="navigation">
      <div class="ul">
        <ul>
          <li class=" home_nav">
            <router-link class="home_nav_aa" :to="{name:'home'}">首页</router-link>
          </li>
          <li class="home_nav" @mouseenter="mouseenter" @mouseleave="mouseleave">
            <router-link class="home_nav_aa" :to="{name:'aa'}">协会概况</router-link>
            <!-- <transition name="fade">
              <div v-show="isShow" @mouseleave="mouseleave" class="navigation_content">
                <li><router-link :to="{name:'Assocpro'}">协会简介</router-link></li>
                 <li><router-link :to="{name:'ContactInfo'}">协会领导</router-link></li>
                <li><router-link :to="{name:'Assocarticle'}">协会章程</router-link></li>
                <li><router-link :to="{name:'Instframe'}">组织机构</router-link></li>
                <li><router-link :to="{name:'Mandirect'}">常务理事</router-link></li>
                <li><router-link :to="{name:'Directunit'}">理事单位</router-link></li>
                <li><router-link :to="{name:'Admiscrit'}">规章制度</router-link></li>
                <li><router-link :to="{name:'Aplymember'}">申请入会</router-link></li>
              </div>
            </transition> -->
          </li>
            <li class="home_nav" @mouseenter="mouseenterC" @mouseleave="mouseleaveC">
            <router-link class="home_nav_aa" :to="{name:'recommend'}">特别推荐</router-link>

          </li>
           <li class="home_nav" @mouseenter="mouseenterI" @mouseleave="mouseleaveI">
            <router-link :to="{name:'Policy'}" class="home_nav_aa">政策法规</router-link>

          </li>

          <!-- <li class="home_nav" @mouseenter="mouseenterB" @mouseleave="mouseleaveB">
            <router-link class="home_nav_aa" :to="{name:'Notifiannou'}">协会要闻</router-link>

          </li> -->
           <li class="home_nav" @mouseenter="mouseenterI" @mouseleave="mouseleaveI">
            <router-link :to="{name:'Assocdynamic'}" class="home_nav_aa">要闻动态</router-link>

          </li>
             <li class="home_nav" @mouseenter="mouseenterI" @mouseleave="mouseleaveI">
            <router-link :to="{name:'directorInformation'}" class="home_nav_aa">理事信息</router-link>

          </li>
             <li class="home_nav" @mouseenter="mouseenterI" @mouseleave="mouseleaveI">
            <router-link :to="{name:'medium'}" class="home_nav_aa">地方融媒体</router-link>

          </li>
            <li class="home_nav" @mouseenter="mouseenterI" @mouseleave="mouseleaveI">
            <router-link :to="{name:'academic'}" class="home_nav_aa">传媒学术</router-link>

          </li>
           <li class="home_nav" @mouseenter="mouseenterI" @mouseleave="mouseleaveI">
            <router-link :to="{name:'Culture'}" class="home_nav_aa">滋文轩</router-link>

          </li>



          <!-- <li class="home_nav"  @mouseenter="mouseenterI" @mouseleave="mouseleaveI">
            <router-link class="home_nav_aa" :to="{name:'Memactive'}">协会党建</router-link>
          </li> -->


           <li class="home_nav" @mouseenter="mouseenterI" @mouseleave="mouseleaveI">
            <router-link :to="{name:'Notice'}" class="home_nav_aa">通知公告</router-link>
          </li>
            <!-- <li class="home_nav" @mouseenter="mouseenterI" @mouseleave="mouseleaveI">
            <router-link :to="{name:'home'}" class="home_nav_aa" >分支机构</router-link>
          </li> -->
        </ul>
      </div>
		</div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data(){
    return{
      activeIndex2:'1',
      lineList:[],
      CooperaBaseList:[],
      isShow:false,
      isShowB:false,
      isShowC:false,
      isShowD:false,
      isShowI:false
    }
  },
  methods:{

    handleSelect(key, keyPath) {
    },
    // 中心概况
    mouseenter(){this.isShow = true;},
    // 中心概况
    mouseleave(){this.isShow = false;},
    // 研究团队
    mouseenterB(){this.isShowB = true;},
    // 研究团队
    mouseleaveB(){this.isShowB = false;},
    // 应用对策
    mouseenterC(){this.isShowC = true;},
    // 应用对策
    mouseleaveC(){this.isShowC = false;},
    // 学者成果
    mouseenterD(){this.isShowD = true;},
    // 学者成果
    mouseleaveD(){this.isShowD = false;},
    // 学术期刊
    mouseenterI(){this.isShowI = true;},
    // 学术期刊
    mouseleaveI(){this.isShowI = false;},
    // 研究团队
    getData(){
      axios.post('/SiteChannelAPI/GetList',{
        PChannelID:2420,
        JournalID:202007100001
      }).then((res) => {
        this.lineList = res.data //_itemList是上面那个结构体
      }).catch((e) => {
        console.log(e);
      })
    },
    // 合作基地
    getDataB(){
      axios.post('/SiteChannelAPI/GetList',{
        PChannelID:2434,
        JournalID:202007100001
      }).then((res) => {
        this.CooperaBaseList = res.data //_itemList是上面那个结构体
      }).catch((e) => {
        console.log(e);
      })
    },
  },
  created(){
    this.getData();
    this.getDataB();
  }
}
</script>

<style lang="less" scoped>
#navigation{
  width: 100%;
  height: 60px;
  position: relative;
  top: -5px;
  .navigation_cont{
    width:100%;
    height:auto;
  }
  .el-menu-demo{
    background: #C01B22!important;
  }
  /deep/.el-menu{
    background: red;
    li{
      background: #C01B22!important;
      color: #fff!important;
    }
  }
  /deep/.el-menu--popup{
    padding:0px!important;
  }
  .ul{
    width: 100%;
    height: 100%;
    margin: 0 auto;
    position: relative;
    background: #C01B22;
  }
  ul{
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    position: relative;
    background: #C01B22;
    .home_nav{
      list-style: none;
      float: left;
      font-weight: bold;
      height: 60px;
      position: relative;
      width: 120px;
      // text-align: center;
      line-height:60px;
      /deep/.el-menu--horizontal>.el-submenu .el-submenu__title{
        height: 100%!important;
        line-height: 47px!important;
      }
      /deep/.el-submenu__title:hover{
        background-color: #C01B22!important;
      }
      .home_nav_aa{
        display: inline-block;
        color: #fff;
        font-size: 20px;
        height: 60px;
        width: 112px;
        position: relative;
        text-align: center;
        line-height: 60px;
      }
      .home_nav_a_i{
        width: 1px;
        height: 16px;
        background: #fff;
        position: r;
        position: absolute;
        top: 23px;
        left: 110px;
      }
    }
    .home_lfer{
      margin-left: 527px;
    }
    li:last-child{
      a{
        border-right: none;
      }
    }
    .router-link-active{
      display: block;
        width: 100%;
        height: 100%;
      background-color: #AB1C22;
      // border-bottom: 1px solid #fff;
    }
    .active{
      a{
        color: #fff;
      }
    }
    li:hover{
      background-color: #AB1C22;
      // a{
      //   border-bottom: 1px solid #fff;
      // }
    }
  }
  .navigation_content{
    width: 144%;
    height: auto;
    position: absolute;
    z-index: 999;
    top: 61px;
    left: -21px;
    background: #fff;
    padding: 10px 0;
    box-shadow: 2px 2px 3px 3px #ccc;
    li{
      text-align: center;
      float: none!important;
      line-height: 36px;
      background: #fff!important;
      height:36px;
      a{
        width: 100%!important;
        font-size: 15px!important;
        color: #333!important;
        top:0px!important;
        border: none!important;
      }
    }
    li:hover{
      background-color: #C01B22!important;
      a{
        color: #fff!important;
      }
    }
  }
  .navigation_contentB{
    width:190%;
    li{
      height:auto!important;
    }
  }
  .navigation_contentC{
    width:140%;
    li{
      height:auto!important;
    }
  }
}
</style>
<style lang="less">
  .el-menu--popup-bottom-start{
    background-color: #C01B22!important;
    padding: 0!important;
  }
  .el-menu--horizontal .el-menu .el-menu-item{
    background-color: #C01B22!important;
    color: #fff!important;
    text-align: center;
    font-size: 16px;
    a{
      font-size: 16px;
      color: #fff!important;
    }
  }
  .el-menu--horizontal .el-menu .el-menu-item:hover{
    background-color: #C01B22!important;
  }
  .el-menu--horizontal .el-menu .el-menu-item:hover .el-menu--horizontal>.el-submenu .el-submenu__title{
    border-bottom-color:none;
  }
  .el-menu--popup{
    min-width: 125px!important;
  }
  .el-menu--horizontal>.el-submenu .el-submenu__title{
    height: 31px!important;
    line-height: 23px!important;
  }
  .el-menu--popup-bottom-start{
    margin-top: 15px!important;
  }

  /deep/.el-menu--horizontal{
    display:block!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/public/navigation/index.vue